import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function LensIcon(props: IconProps) {
    return <Icon {...props} iconKey={"lens"}/>
}
